import { Vue, App, store } from "./main"

new Vue({
  store,
  render: (h) => h(App),
}).$mount("#app")
